import React from 'react';

import TextBase from './TextBase';
import { TText } from './types';

const BodySmall = ({ as = 'span', color, strong = false, ...rest }: TText) => (
  <TextBase as={as} kind={strong ? 'body-small-strong' : 'body-small-regular'} color={color} {...rest} />
);

export default BodySmall;
